module.exports = __webpack_public_path__ + "img/keralastartupmission.5c2ccc7f.png";